export const AI_PLAYGROUND_CONSTANTS = {
  LABELS: {
    SELECT_PROMPT: "Select a Prompt",
    CHOOSE_CATEGORY: "Choose a category",
    KUSTO_QUERY: "Kusto Query",
    PROMPT: "Prompt",
    RESULTS: "Results",
    SAVE_SESSION: "Save Session",
    UPDATE_SCHEDULES: "Update Schedules",
    SESSION_NAME: "Session Name",
    FREQUENCY: "Frequency",
    STATUS: "Status",
    ADD: "Add",
    SAVE_CHANGES: "Save Changes",
    CLOSE: "Close",
    DOWNLOAD_RESULTS: "Download Results",
    DOWNLOAD_DOCX: "Download in DOCX",
    SEND_EMAIL: "Send Results in Email (coming soon...)",
    RUN: "Run",
    RUNNING: "Running",
    SAVED_SUCCESS: "Saved successfully",
    CANCEL: "Cancel",
    CHANGES_SAVED: "Changes Saved"
  },
  MESSAGES: {
    NO_PROMPT: "No prompt was provided. Please enter a valid prompt to continue.",
    NO_QUERY: "No query was provided. Please enter a valid query to proceed.",
    NO_RESULTS: "No results generated.",
    RESULTS_PLACEHOLDER: "Results will be displayed here...",
    NOTHING_TO_COPY: "Nothing to copy!",
    COPIED: "Copied to clipboard!",
    COPY_FAILED: "Failed to copy to clipboard. Please try again.",
    NO_DATA_TO_DOWNLOAD: "No data to download!",
    GENERATE_DOWNLOAD_ERROR:
      "Sorry, we couldn't generate your download. Please try again or contact support if the issue persists.",
    DOCX_ERROR: "Failed to generate DOCX file. Please try again.",
    COMPLETE_FIELDS: "Please complete all required fields before proceeding.",
    SESSION_NAME_REQUIRED: "Session name required!",
    ERROR_MESSAGE: `We encountered an unexpected issue while processing your request.  
Please ensure the following:

1. ✅ The KQL query does **not contain any syntax errors**.
    - Try running it in the **[Azure Data Explorer Web UI](https://dataexplorer.azure.com/)**  
    - The results of the KQL query is **less than 1,000,000 tokens** (approx. 3,500,000 characters as a safe bet).

2. ✅ The model might have **exceeded its per-minute token limit**.  
    - Please retry after a few minutes.

---

If none of these issues apply, stay put—our development team has been notified and will investigate further.  
We'll get back to you at the earliest.  

**Error Code:**`,
    SAVE_SESSION_ERROR: "Failed to save session. Please try again.",
    DEFAULT_ERROR_MESSAGE: "We encountered an unexpected issue while processing your request."
  },
  ICONS: {
    CUSTOM: "Custom",
    LOADING: "Loading",
    USER: "👤",
    SYSTEM: "🤖"
  },
  FREQUENCIES: ["daily", "weekly", "monthly"],
  STATUSES: ["active", "inactive"],
  DOCX_FILENAME: "Query_Results.docx",
  SCHEDULE_OPTIONS: [
    { key: "yes", text: "Yes" },
    { key: "no", text: "No" }
  ],
  SCHEDULE_FREQUENCY_OPTIONS: [
    { key: "daily", text: "Daily" },
    { key: "weekly", text: "Weekly" },
    { key: "monthly", text: "Monthly" }
  ],
  // Error color constants aligned with Microsoft Design Language
  ERROR_COLORS: {
    background: "#fef7f7",
    border: "#f87171",
    borderAccent: "#dc2626",
    text: "#991b1b",
    troubleshootingBackground: "#fef2f2",
    troubleshootingText: "#7f1d1d",
    buttonPrimary: "#dc2626",
    buttonPrimaryHover: "#b91c1c"
  } as const,
  TROUBLESHOOTING_TIPS: [
    "Check your internet connection",
    "Verify that your query syntax is correct",
    "Try simplifying your request",
    "Wait a moment and try again"
  ] as const,
  // Constants for timeouts
  TIMEOUT_DELAYS: {
    RUN_PROMPT: 200,
    SAVE_RESET: 2000,
    DELETE_RESET: 2000,
    BULK_UPDATE_RESET: 2000
  } as const,
  SCHEDULE_FREQUENCY: {
    NOT_APPLICABLE: "N/A",
    EMPTY: ""
  } as const,
  // Error messages to log for specific API errors
  API_ERROR_MESSAGES: [
    "ai agent response error",
    "kusto query data size exceeded",
    "kql query execution error"
  ] as const,
  NAVIGATION: {
    TOP_LEVEL_TABS: [
      { key: "copilotchat", headerText: "Copilot" },
      { key: "kqlmode", headerText: "KQL Mode" },
    ],
    NESTED_TABS: [
      { key: "home", headerText: "Home" },
      { key: "sessions", headerText: "My Sessions" },
      { key: "library", headerText: "Prompt Library" },
    ]
  } as const
};
// Access nested constants
export const labels = AI_PLAYGROUND_CONSTANTS.LABELS;
export const messages = AI_PLAYGROUND_CONSTANTS.MESSAGES;
export const errorColors = AI_PLAYGROUND_CONSTANTS.ERROR_COLORS;
export const troubleshootingTips = AI_PLAYGROUND_CONSTANTS.TROUBLESHOOTING_TIPS;
export const timeoutDelays = AI_PLAYGROUND_CONSTANTS.TIMEOUT_DELAYS;
export const scheduleFrequency = AI_PLAYGROUND_CONSTANTS.SCHEDULE_FREQUENCY;
export const apiErrorMessages = AI_PLAYGROUND_CONSTANTS.API_ERROR_MESSAGES;
export const navigation = AI_PLAYGROUND_CONSTANTS.NAVIGATION;
